import * as React from "react";
function SvgArrowLeftIcon(props: React.SVGProps<SVGSVGElement>) {
  return <svg xmlns="http://www.w3.org/2000/svg" width={11.142} height={20} viewBox="0 0 11.142 20" {...props}><path d="M6.67,10.08l-5-7.118A22.6,22.6,0,0,0,0,.732L1.289,0,5.6,4.363C7.449,6.21,9.3,7.962,11.142,9.745v.669l-6.16,5.939C3.693,17.643,2.4,18.822,1.289,20L0,19.108Z" transform="translate(11.142 20) rotate(180)" /></svg>;
}
export default SvgArrowLeftIcon;